import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD44AWCx1yC5U8GeCE0X900P8aN9zuu_s8",
  authDomain: "sikolog-9e45a.firebaseapp.com",
  projectId: "sikolog-9e45a",
  storageBucket: "sikolog-9e45a.firebasestorage.app",
  messagingSenderId: "596768140524",
  appId: "1:596768140524:web:1cdbf40157d1a01ae309c9",
  measurementId: "G-WGBXYG0C0G"
};

// Firebase初期化
const app = initializeApp(firebaseConfig);

// Authentication
export const auth = getAuth(app);

// Firestore
export const db = getFirestore(app);

export default app;